





























































































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { actionsEvent } from '@/setup';
import { Snotify } from '@/snotify/Snotify';

const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  ColumnApi,
  GridReadyEvent,
  ValueFormatterParams,
} from 'ag-grid-community';
import { checkboxColumnDef } from '@/reusable/Grid/aggridColumnDefUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';

import { LoadingService } from '@/services/loadingService';
import { Funcionalidades } from '@/config/funcionalidades';
import { ComponenteBase, Accion } from '@/views/base/ComponenteBase';
import BuscadorOperacionCrud from '@/reusable/Grid/BuscadorOperacionCrud.vue';
import AsociacionGrid from '@/reusable/Grid/AsociacionGrid.vue';
import MantenedorGridVerDetalle from '@/reusable/Grid/MantenedorGridVerDetalle.vue';
import AgregarButton from '@/reusable/Grid/AgregarButton.vue';
import AgregarButton2 from '@/reusable/Grid/AgregarButton2.vue';
import config from '@/config/index';
import store from '@/store';

import { ServicioProxy, TipoFrecuenciasCalendario } from '@/config/enums';
import moment from 'moment';
import { AxiosVue } from '@/AxiosVue';
import StepTitle from '@/reusable/Mantenedor/StepTitle.vue';

import CrearCalendarioModal from '@/pantallas/Alertas/CrearCalendarioModal.vue';
import { CalendarioNuevoForm } from '@/pantallas/Calendarios/Calendario';

import {
  fetchListDistrContactosUsuarios,
  ListDistrContactosUsuarios,
  fetchListDistrContactosUsuariosPg
} from '@/reusable/ListDistrContactosUsuarios/fetchListDistrContactosUsuarios';

import { crearCalendario } from '@/pantallas/Alertas/Services/crearCalendario';
import { fetchCalendarios } from '@/pantallas/Alertas/Services/fetchCalendarios';
import { TipoNotificacion, AlertaBackend } from '@/interfaces/Alertas';
import {
  FormFieldDefMap,
  emitFormChangeEvent,
} from '@/reusable/Form/formUtils';
import { MarcaBlanca } from '@/config/marcaBlanca.ts';

@Component({
  components: {
    StepTitle,
    BuscadorOperacionCrud,
    AsociacionGrid,
    MantenedorGridVerDetalle,
    AgregarButton,
    AgregarButton2,
    FormFieldsContainer,
    CrearCalendarioModal,
  },
})
export default class ConfigurarNotificacionForm extends Vue {
  @Prop({ default: false }) modoVer: boolean;
  @Prop({ default: false }) modoEditar: boolean;
  @Prop() alertaSeleccionada: AlertaBackend;
  marcaBlanca: MarcaBlanca = new MarcaBlanca();

  formFields: FormFieldDefMap = {
    notificaGps: {
      label: 'Plataforma GPS',
      id: 'notificaGps',
      value: false,
    },
    notificaBrowser: {
      label: 'Navegador',
      id: 'notificaBrowser',
      value: false,
    },
    notificaEmail: {
      label: 'Email',
      id: 'notificaEmail',
      value: false,
    },
  };

  lstTipoNotificacion: any = [
    {
      id: 1,
      value: 'Lista de Distribución',
    },
    {
      id: 2,
      value: 'Contactos',
    },
    {
      id: 3,
      value: 'Usuarios',
    },
  ];

  /* state */

  tipoNotificacion = 1;
  mostrarModalCalendario: boolean = false;
  lstDistribucion: TipoNotificacion[] = [];
  lstDistribucionSeleccionada: TipoNotificacion[] = [];
  lstContactos: TipoNotificacion[] = [];
  lstContactosSeleccionada: TipoNotificacion[] = [];
  lstUsuarios: TipoNotificacion[] = [];
  lstUsuariosSeleccionados: TipoNotificacion[] = [];
  lstCalendario: CalendarioNuevoForm[] = [];
  lstCalendarioSeleccionado: CalendarioNuevoForm[] = [];

  axiosAlerta: AxiosVue = new AxiosVue(ServicioProxy.Alerta);

  /* aggrid */

  gridApiListaDistribucion: GridApi = null;
  gridApiContacto: GridApi = null;
  gridApiUsuario: GridApi = null;
  gridApiCalendario: GridApi = null;

  /* template */

  readonly gridOptionsListaDistribucion: GridOptions = {
    columnDefs: [
      {
        headerName: 'Código',
        field: 'id',
        hide: true,
      },
      {
        headerName: 'Nombre',
        field: 'nombre',
        lockVisible: true,
      },
      {
        headerName: 'Tipo',
        field: 'tipo',
      },
      {
        headerName: 'Correo Electrónico',
        field: 'email',
      },
    ],
    onGridReady: this.handleGridListaDistribucionReady,
    onSelectionChanged: this.handleListaDistribucionCheck,
  };

  readonly gridOptionsContacto: GridOptions = {
    columnDefs: [
      {
        headerName: 'Código',
        field: 'id',
        hide: true,
      },
      {
        headerName: 'Nombre',
        field: 'nombre',
        lockVisible: true,
      },
      {
        headerName: 'Tipo',
        field: 'tipo',
      },
      {
        headerName: 'Correo Electrónico',
        field: 'email',
      },
    ],
    onGridReady: this.handleGridContactoReady,
    onSelectionChanged: this.handleContactoCheck,
  };

  readonly gridOptionsUsuarios: GridOptions = {
    columnDefs: [
      {
        headerName: 'Código',
        field: 'id',
        hide: true,
      },
      {
        headerName: 'Nombre',
        field: 'nombre',
        lockVisible: true,
      },
      {
        headerName: 'Tipo',
        field: 'tipo',
      },
      {
        headerName: 'Correo Electrónico',
        field: 'email',
      },
    ],
    onGridReady: this.handleGridUsuarioReady,
    onSelectionChanged: this.handleUsuarioCheck,
  };

  readonly gridOptionsCalendario: GridOptions = {
    columnDefs: [
      {
        headerName: 'Código',
        field: 'id',
        hide: true,
      },
      {
        headerName: 'Nombre',
        field: 'nombreCalendario',
        lockVisible: true,
      },
      {
        headerName: 'Frecuencia',
        field: 'frecuenciaSeleccionada',
        cellRenderer: (r: any) => {
          return TipoFrecuenciasCalendario[r.data.frecuenciaSeleccionada];
        },
      },
      {
        headerName: 'Fecha Inicio',
        field: 'fechaInicioTxt',
      },
      {
        headerName: 'Fecha Fin',
        field: 'fechaFinTxt',
      },
    ],
    rowSelection: 'single',
    onGridReady: this.handleGridCalendarioReady,
    onSelectionChanged: this.handleSeleccionCalendario,
  };

  /* misc */

  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  async mounted() {
    this.handleFormChange(this.formFields);
    this.handleAlertaSeleccionadaChange();

    if(this.marcaBlanca.getSubDomain() == 'gpschile'){
      this.lstTipoNotificacion = [
        {
          id: 1,
          value: 'Lista de Distribución',
        },
        {
          id: 2,
          value: 'Contactos',
        },
        {
          id: 3,
          value: 'Usuarios',
        },
      ];
      this.tipoNotificacion = 1;
    }else{
      this.lstTipoNotificacion = [
        {
          id: 3,
          value: 'Usuarios',
        },
      ];
      this.tipoNotificacion = 3;
    }
  }

  /* Modo editar y ver */

  setListaDistribucionSeleccionadas() {
    this.lstDistribucionSeleccionada = [];
    if (this.alertaSeleccionada) {
      if (
        this.alertaSeleccionada.notificacionListaDistribucion &&
        this.alertaSeleccionada.notificacionListaDistribucion.length > 0
      ) {
        this.alertaSeleccionada.notificacionListaDistribucion.forEach(l => {
          this.lstDistribucionSeleccionada.push(
            this.lstDistribucion.find(c => c.id == l)
          );
          this.gridApiListaDistribucion.forEachNode(function(node: any) {
            if (node.data.id == l) {
              node.setSelected(true);
            }
          });
        });
      }
    }
  }

  setContactosSeleccionados() {
    this.lstContactosSeleccionada = [];
    if (this.alertaSeleccionada) {
      if (
        this.alertaSeleccionada.notificacionContacto &&
        this.alertaSeleccionada.notificacionContacto.length > 0
      ) {
        this.alertaSeleccionada.notificacionContacto.forEach(l => {
          this.lstContactosSeleccionada.push(
            this.lstContactos.find(c => c.id == l)
          );
          this.gridApiContacto.forEachNode(function(node: any) {
            if (node.data.id == l) {
              node.setSelected(true);
            }
          });
        });
      }
    }
  }

  setUsuariosSeleccionados() {
    this.lstUsuariosSeleccionados = [];
    if (this.alertaSeleccionada) {
      if (
        this.alertaSeleccionada.notificacionUsuario &&
        this.alertaSeleccionada.notificacionUsuario.length > 0
      ) {
        this.alertaSeleccionada.notificacionUsuario.forEach(l => {
          this.lstUsuariosSeleccionados.push(
            this.lstUsuarios.find(c => c.id == l)
          );
          this.gridApiUsuario.forEachNode(function(node: any) {
            if (node.data.id == l) {
              node.setSelected(true);
            }
          });
        });
      }
    }
  }

  setCalendariosSeleccionados() {
    this.lstCalendarioSeleccionado = [];
    if (this.alertaSeleccionada) {
      if (this.alertaSeleccionada.notificacionCalendario) {
        this.alertaSeleccionada.notificacionCalendario.forEach(l => {
          this.lstCalendarioSeleccionado.push(
            this.lstCalendario.find(c => c.id == l)
          );
          this.gridApiCalendario.forEachNode(function(node: any) {
            if (node.data.id == l) {
              node.setSelected(true);
            }
          });
        });
      }
    }
  }

  /* Tipo notificacion */

  async cargarListDistrContactosUsuarios() {
    const response = await this.fetchListDistrContactosUsuarios();
    if (!response) {
      return;
    }

    this.lstDistribucion = response.listaDistribucion;
    this.lstContactos = response.contactos;
    this.lstUsuarios = response.usuarios;

    this.gridApiListaDistribucion.setRowData(this.lstDistribucion);
    this.gridApiContacto.setRowData(this.lstContactos);
    this.gridApiUsuario.setRowData(this.lstUsuarios);

    this.setListaDistribucionSeleccionadas();
    this.setContactosSeleccionados();
    this.setUsuariosSeleccionados();
  }

  fetchListDistrContactosUsuarios() {
    this.loadingService.showLoading();
    return fetchListDistrContactosUsuariosPg()
      .catch(error => {
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            this.$snotify.error(
              'Ocurrió un error al obtener lista de distribución'
            );
          }
        } else {
          this.$snotify.error(
            'Ocurrió un error al obtener lista de distribución'
          );
        }
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  async handleGridListaDistribucionReady(event: GridReadyEvent) {
    this.gridApiListaDistribucion = event.api;
    await this.cargarListDistrContactosUsuarios();
  }

  async handleGridContactoReady(event: GridReadyEvent) {
    this.gridApiContacto = event.api;
  }

  async handleGridUsuarioReady(event: GridReadyEvent) {
    this.gridApiUsuario = event.api;
  }

  handleListaDistribucionCheck() {
    var seleccion: number[] = [];
    if (this.gridApiListaDistribucion.getSelectedRows().length > 0) {
      this.gridApiListaDistribucion.getSelectedRows().forEach(d => {
        seleccion.push(d.id);
      });
    }

    this.$emit('distribucionSelect', seleccion, 1);
  }

  handleContactoCheck() {
    var seleccion: number[] = [];
    if (this.gridApiContacto.getSelectedRows().length > 0) {
      this.gridApiContacto.getSelectedRows().forEach(d => {
        seleccion.push(d.id);
      });
    }

    this.$emit('distribucionSelect', seleccion, 2);
  }

  handleUsuarioCheck() {
    var seleccion: number[] = [];
    if (this.gridApiUsuario.getSelectedRows().length > 0) {
      this.gridApiUsuario.getSelectedRows().forEach(d => {
        seleccion.push(d.id);
      });
    }

    this.$emit('distribucionSelect', seleccion, 3);
  }

  handledTipoNotificacion() {
    this.$emit('tipoNotificacionSeleccionado', this.tipoNotificacion);
  }

  /* Tipo de notificacion */

  @Watch('formFields', { deep: true })
  handleFormChange(fields: FormFieldDefMap) {
    emitFormChangeEvent(this.$emit.bind(this), {
      entity: {
        notificaGps: fields.notificaGps.value,
        notificaBrowser: fields.notificaBrowser.value,
        notificaEmail: fields.notificaEmail.value,
      } as AlertaBackend,
      validator: this.$validator,
      isDirty: Object.keys(this.fields).some(key => this.fields[key].dirty),
    });
  }

  @Watch('alertaSeleccionada', { deep: true })
  handleAlertaSeleccionadaChange() {
    if (this.alertaSeleccionada) {
      this.formFields.notificaGps.value = this.alertaSeleccionada.notificaGps;
      this.formFields.notificaBrowser.value = this.alertaSeleccionada.notificaBrowser;
      this.formFields.notificaEmail.value = this.alertaSeleccionada.notificaEmail;
    }
  }

  /* Calendario */

  fetchLstCalendario() {
    this.loadingService.showLoading();
    fetchCalendarios()
      .then(res => {
        this.lstCalendario = res;
        this.gridApiCalendario.setRowData(this.lstCalendario);
        this.setCalendariosSeleccionados();
      })
      .catch(error => {
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            this.$snotify.error(
              'Ocurrió un error al obtener lista de calendario'
            );
          }
        } else {
          this.$snotify.error(
            'Ocurrió un error al obtener lista de calendario'
          );
        }
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  async handleGridCalendarioReady(event: GridReadyEvent) {
    this.gridApiCalendario = event.api;
    this.fetchLstCalendario();
  }

  handleSeleccionCalendario() {
    var seleccion: number[] = [];
    if (this.gridApiCalendario.getSelectedRows().length > 0) {
      this.gridApiCalendario.getSelectedRows().forEach(c => {
        seleccion.push(c.id);
      });
    }

    this.$emit('calendarioSelect', seleccion);
  }

  handleCrearCalendario() {
    this.mostrarModalCalendario = true;
  }

  handleCierreModal() {
    this.mostrarModalCalendario = false;
  }

  handleNuevoCalendario(calendario: CalendarioNuevoForm) {
    this.loadingService.showLoading();

    if (!this.lstCalendario) {
      this.lstCalendario = [];
    }

    calendario.fechaInicioTxt = calendario.fechaInicio
      ? this.formatFecha(calendario.fechaInicio)
      : '';

    calendario.fechaFinTxt = calendario.fechaFin
      ? this.formatFecha(calendario.fechaFin)
      : '';

    crearCalendario(calendario)
      .then(res => {
        //@ts-ignore
        calendario.id = res.data;
        this.$snotify.success(
          this.$t('mensajes.mensajesExito.crear', {
            entidad: 'Calendario',
            creadoA: 'agregado',
          })
        );

        this.lstCalendario.push(calendario);
        this.gridApiCalendario.setRowData(this.lstCalendario);

        this.loadingService.hideLoading();
      })
      .catch(error => {
        this.loadingService.hideLoading();
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            this.$snotify.error(
              this.$t('mensajes.mensajesError.crear', {
                entidad: 'Calendario',
              })
            );
          }
        } else {
          this.$snotify.error(
            this.$t('mensajes.mensajesError.crear', {
              entidad: 'Calendario',
            })
          );
        }
      });
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }
}
